<shared-search-form (onToggleOpen)="handleToggleOpen($event)" [open]="open" class="search-for-products-filter"
    [enableSubmit]="enableSubmit" [enableClear]="enableClear" [enableClose]="enableClose" [placeholder]="placeholder"
    (onValueChange)="onSearchType($event)" (onSearchReset)="onSearchReset($event)" mode="filter">
</shared-search-form>
